import { render, staticRenderFns } from "./quill.vue?vue&type=template&id=4f810d38&scoped=true"
import script from "./quill.vue?vue&type=script&lang=js"
export * from "./quill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f810d38",
  null
  
)

export default component.exports